import Axios from 'axios';
import { protectedResources } from '../authConfig';

const URL =
  protectedResources.apiHRMobile.baseApi +
  '/api/v1/AdvanceSalary/SetAdvanceSararyRequestStateCanceled';
let tokenKey;

export async function delRequestSalary(id = null) {
  if (sessionStorage.getItem('AccessToken') !== null) {
    tokenKey = JSON.parse(sessionStorage.getItem('AccessToken')).value;
  }

  const config = {
    headers: { Authorization: `Bearer ${tokenKey}` },
  };

  const bodyParameters = {
    id: id,
  };

  try {
    if (id != null) {
      const response = await Axios.post(URL, bodyParameters, config);
      return await response;
    }
  } catch (error) {
    if (error?.response?.status == 401) {
      localStorage.removeItem("obj_user_info");
      sessionStorage.removeItem("AccessToken");
      throw new Error("Unauthorized");
    }
    
    
    throw error;
  }
}
